import blogs from './blogs/index'

export default [
    ...blogs,
]